import * as React from 'react';
import {styledDiv, styled} from '@packages/utilities/styled';
import {
  EmailIcon,
  CMSAddIcon,
  HelpOutlineIcon,
  CMSDeleteIcon,
  CMSUpdateIcon,
  CMSSearchIcon,
} from '@packages/systems/spring';

const FlowIconWrapper = styledDiv(
  ({theme: {colors, gutters}}) => ({
    gridRow: '1 / 3',
    width: gutters.x12 * 3,
    height: gutters.x12 * 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${colors.border}`,
    borderRadius: '4px',
    color: colors.white,
    backgroundColor: colors.background,
  }),
  {
    dynamic: ({theme: {colors}}) => ({
      backgroundColor: colors.logicFlows.backgroundVivid,
    }),
    email: ({theme: {colors}}) => ({
      backgroundColor: colors.accentBackground,
    }),
    trigger: {
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: 0,
    },
  }
);

export const EmailNotification = () => {
  return (
    <FlowIconWrapper email>
      <EmailIcon size={20} />
    </FlowIconWrapper>
  );
};

export const CreateCMSIconMedium = () => {
  return (
    <FlowIconWrapper dynamic>
      <CMSAddIcon size={20} />
    </FlowIconWrapper>
  );
};

export const DeleteCMSIconMedium = () => {
  return (
    <FlowIconWrapper dynamic>
      <CMSDeleteIcon size={20} />
    </FlowIconWrapper>
  );
};

export const UpdateCMSIconMedium = () => {
  return (
    <FlowIconWrapper dynamic>
      <CMSUpdateIcon size={20} />
    </FlowIconWrapper>
  );
};

export const CMSItemCreatedIconMedium = () => {
  return (
    <FlowIconWrapper dynamic trigger>
      <CMSAddIcon size={20} />
    </FlowIconWrapper>
  );
};

export const CMSItemDeletedIconMedium = () => {
  return (
    <FlowIconWrapper dynamic trigger>
      <CMSDeleteIcon size={20} />
    </FlowIconWrapper>
  );
};

export const CMSItemUpdatedIconMedium = () => {
  return (
    <FlowIconWrapper dynamic trigger>
      <CMSUpdateIcon size={20} />
    </FlowIconWrapper>
  );
};

export const LookupCMSIconMedium = () => {
  return (
    <FlowIconWrapper dynamic>
      <CMSSearchIcon size={20} />
    </FlowIconWrapper>
  );
};

export const StyledHelpIcon = styled(HelpOutlineIcon)(({theme}) => ({
  width: theme.control.height / 2,
  height: theme.control.height / 2,
  boxSizing: 'content-box',
  color: theme.colors.foregroundDim,
  position: 'relative',
  top: '2px',
}));
